import { Country } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getScrubCountries: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<Country[]> = (fetchContext, programId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/scrub-countries`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Country[]>(fetchContext.errorStore, response, 'get scrub countries'));
